// Auto-generated by cli-contracts. Do not edit.
import { Command } from "commander";
import { CONTRACT_YAML, CONTRACT_JSON_STR } from "./contract.js";

export interface CommandHandlers {
  init: (config: string | undefined, options: Record<string, never>, parentOpts: Record<string, unknown>) => Promise<void>;
  audit: (target: string | undefined, options: { adapter?: string; model?: string; showPrompt?: boolean; failOn?: string; output?: string; reportFormat?: string; logFile?: string }, parentOpts: Record<string, unknown>) => Promise<void | string>;
  implement: (description: string | undefined, options: { target?: string; models?: string; adapter?: string; model?: string; showPrompt?: boolean; failOn?: string; output?: string; reportFormat?: string; logFile?: string }, parentOpts: Record<string, unknown>) => Promise<void | string>;
  agents: (options: { format?: string }, parentOpts: Record<string, unknown>) => Promise<void>;
  insights: (options: { format?: string; projectRoot?: string; config?: string }, parentOpts: Record<string, unknown>) => Promise<void>;
}

export function createProgram(
  handlers: CommandHandlers,
  version: string,
): Command {
  const program = new Command();
  program
    .name("litedbmodel-gen")
    .version(version, "-V, --version")
    .description("embedoc-based model code generator for litedbmodel.");


  program
    .command("init")
    .description("Set up litedbmodel-gen in an embedoc project.")
    .argument("[config]", "Path to embedoc.config.yaml. Defaults to embedoc.config.yaml in the current directory.")
    .action(async (config, opts, cmd) => {
      await handlers.init(config, {}, cmd.optsWithGlobals());
    });

  program
    .command("audit")
    .description("Audit litedbmodel usage code for common anti-patterns.")
    .argument("[target]", "File or directory path to audit. Defaults to the current working directory.")
    .option("--adapter <value>", "LLM adapter to use for the audit.", "mock")
    .option("--model <value>", "Model name override for the selected adapter.")
    .option("--show-prompt", "Output the constructed prompt without calling the LLM API.", false)
    .option("--fail-on <value>", "Minimum finding severity that causes exit code 10. Findings below this threshold are still reported.", "error")
    .option("-o, --output <value>", "Write the report to a file instead of stdout.")
    .option("--report-format <value>", "Output format for the audit report.", "json")
    .option("-l, --log-file <value>", "File path to write structured progress logs.")
    .action(async (target, opts, cmd) => {
      if (opts.showPrompt) {
        const prompt = await handlers.audit(target, opts, cmd.optsWithGlobals());
        if (typeof prompt === "string") process.stdout.write(prompt + "\n");
        return;
      }
      await handlers.audit(target, opts, cmd.optsWithGlobals());
    });

  program
    .command("implement")
    .description("Implement a feature using litedbmodel best practices.")
    .argument("<description>", "Natural-language description of the feature to implement. Should specify the function name, target file, and business logic.")
    .option("-t, --target <value>", "Target source file(s) to create or edit. The agent reads these files to understand existing code and writes the implementation to them.")
    .option("--models <value>", "Glob pattern for model definition files. The agent reads these to understand available models, columns, and relations.", "models/**/*.ts")
    .option("--adapter <value>", "LLM adapter to use for code generation.", "mock")
    .option("--model <value>", "Model name override for the selected adapter.")
    .option("--show-prompt", "Output the constructed prompt without calling the LLM API.", false)
    .option("--fail-on <value>", "Minimum finding severity that causes exit code 10. Design concerns (info/warning) are still reported at exit 0.", "error")
    .option("-o, --output <value>", "Write the report to a file instead of stdout.")
    .option("--report-format <value>", "Output format for the implementation report.", "json")
    .option("-l, --log-file <value>", "File path to write structured progress logs.")
    .action(async (description, opts, cmd) => {
      if (opts.showPrompt) {
        const prompt = await handlers.implement(description, opts, cmd.optsWithGlobals());
        if (typeof prompt === "string") process.stdout.write(prompt + "\n");
        return;
      }
      await handlers.implement(description, opts, cmd.optsWithGlobals());
    });

  program
    .command("insights")
    .description("Export SQL schema → model file edges as ExternalInsight JSON.")
    .option("--format <format>", "Output format (json only).", "json")
    .option("--project-root <path>", "Project root directory containing embedoc.config.yaml.", ".")
    .option("-c, --config <path>", "Path to embedoc.config.yaml.")
    .action(async (opts, cmd) => {
      await handlers.insights(opts, cmd.optsWithGlobals());
    });

  program
    .command("agents")
    .description("Output the full resolved agent DSL as structured data.")
    .option("-F, --format <value>", "Output format.", "yaml")
    .action(async (opts, cmd) => {
      await handlers.agents(opts, cmd.optsWithGlobals());
    });


  // Built-in extract command (auto-injected by cli-contracts)
  program
    .command("extract")
    .description("Extract contract specification for this CLI tool.")
    .argument("[commands...]", "Command IDs to extract. Use dot notation.")
    .option("-a, --all", "Extract all commands.", false)
    .option("--include-meta", "Include extraction metadata.", true)
    .option("-F, --format <format>", "Output format (yaml or json).", "yaml")
    .action(async (commands: string[], opts: { all?: boolean; includeMeta?: boolean; format?: string }, cmd: Command) => {
      if (commands.length === 0 && !opts.all) {
        process.stderr.write(JSON.stringify({ code: "INVALID_ARGS", message: "Specify command IDs or use --all" }) + "\n");
        process.exit(2);
      }

      const format = opts.format || "yaml";
      const doc = JSON.parse(CONTRACT_JSON_STR);
      const cmdIds = opts.all ? [] : commands;

      if (cmdIds.length === 0) {
        // --all: output full contract
        if (format === "json") {
          const out: Record<string, unknown> = {};
          if (opts.includeMeta) {
            out._meta = {
              source: "embedded",
              type: "cli-contracts/extract",
              extractedAt: new Date().toISOString(),
              specVersion: doc.cli_contracts ?? "0.1.0",
              commands: ["litedbmodel-gen.init","litedbmodel-gen.audit","litedbmodel-gen.implement","litedbmodel-gen.agents"],
            };
          }
          Object.assign(out, doc);
          process.stdout.write(JSON.stringify(out, null, 2) + "\n");
        } else {
          // YAML output
          const yamlLines: string[] = [];
          yamlLines.push("# litedbmodel-gen extract");
          yamlLines.push("# source: embedded");
          yamlLines.push("# type: cli-contracts/command-extract");
          if (opts.includeMeta) {
            yamlLines.push("---");
            yamlLines.push("source: embedded");
            yamlLines.push("type: cli-contracts/command-extract");
            yamlLines.push("extractedAt: " + new Date().toISOString());
            yamlLines.push("spec_version: " + (doc.cli_contracts ?? "0.1.0"));
            yamlLines.push("commands:");
            for (const id of ["litedbmodel-gen.init","litedbmodel-gen.audit","litedbmodel-gen.implement","litedbmodel-gen.agents"]) {
              yamlLines.push("  - " + id);
            }
          }
          yamlLines.push("---");
          yamlLines.push(CONTRACT_YAML);
          process.stdout.write(yamlLines.join("\n") + "\n");
        }
      } else {
        // Filter specific commands
        const filtered: Record<string, unknown> = {
          cli_contracts: doc.cli_contracts,
          info: doc.info,
          command_sets: {},
        };
        const fcs = filtered.command_sets as Record<string, Record<string, unknown>>;
        for (const [setId, cs] of Object.entries(doc.command_sets ?? {})) {
          const cmds = (cs as Record<string, unknown>).commands as Record<string, unknown> | undefined;
          if (!cmds) continue;
          const matched: Record<string, unknown> = {};
          for (const [cmdId, cmdDef] of Object.entries(cmds)) {
            const fullId = setId + "." + cmdId;
            if (cmdIds.some((id) => id === cmdId || id === fullId || cmdId.startsWith(id + "."))) {
              matched[cmdId] = cmdDef;
            }
          }
          if (Object.keys(matched).length > 0) {
            const setCopy = { ...(cs as Record<string, unknown>) };
            setCopy.commands = matched;
            fcs[setId] = setCopy;
          }
        }
        if (doc.components) filtered.components = doc.components;
        process.stdout.write(JSON.stringify(filtered, null, 2) + "\n");
      }
      process.exit(0);
    });
  return program;
}
